<template>
  <div
    v-if="context"
    class="tw-relative tw-z-0 tw-flex tw-flex-col tw-overflow-y-auto"
    :style="containerStyle"
    data-walkthrough-id="workflow-review-communication"
    data-behaviour="workflow-review-sidepane"
    data-testid="sidepane-container"
    :data-context-id="context.id"
    :data-context-type="context.itemClass"
    @click.stop="clearHighlightedCard"
  >
    <SidepaneCommunication
      empty-translation-key="communication.workflow_review_empty_state"
    />
  </div>
</template>

<script>
import { mapActions as mapPiniaActions, mapState as mapPiniaState } from 'pinia'
import { mapState } from 'vuex'
import SidepaneCommunication from '@app/application/communication/sections/communication/components/sidepane-communication'
import registerSidepanePageVisitMixin from '@app/shared/vue/mixins/register-sidepane-page-visit'

import { useWorfklowReviewItems } from '../store/pinia/workflow-review-items'
import { useDrawer } from '@app/shared/pinia/drawer'
import { useHighlightedCard } from '@app/shared/pinia/highlighted-card'
import { useHeightStore } from '@app/shared/vue/store/height-store'

export default {
  name: 'WorkflowReviewSidepane',
  components: {
    SidepaneCommunication,
  },
  mixins: [registerSidepanePageVisitMixin],
  props: {
    ledgerId: {
      type: [String, Number],
      required: true,
    },
    ledgerLabel: {
      type: String,
      required: true,
    },
  },
  emits: ['clearAnchor'],
  computed: {
    ...mapState({
      fetchingCommunicationsStatus: (state) =>
        state.ui.fetchingCommunicationsStatus,
    }),
    ...mapPiniaState(useWorfklowReviewItems, {
      context: 'currentReviewItem',
    }),
    ...mapPiniaState(useDrawer, ['isRightDrawerOpen']),
    ...mapPiniaState(useHighlightedCard, ['highlightedCard']),
    ...mapPiniaState(useHeightStore, ['communicationSidepaneHeight']),
    // needed for the registerSidepanePageVisit mixin
    contextType() {
      return this.context?.itemClass
    },
    contextId() {
      return this.context?.id
    },
    containerStyle() {
      return {
        maxHeight: `calc(100% - ${this.communicationSidepaneHeight})`,
      }
    },
  },
  created() {
    window.eventHub.$on('openSidepane', this.effectiveOpenDrawer)
  },
  beforeUnmount() {
    window.eventHub.$off('openSidepane', this.effectiveOpenDrawer)
  },
  methods: {
    ...mapPiniaActions(useDrawer, ['openRightDrawer', 'closeRightDrawer']),
    ...mapPiniaActions(useHighlightedCard, ['unsetHighlightedCard']),
    clearHighlightedCard() {
      if (this.highlightedCard.id) {
        this.unsetHighlightedCard()
        window.eventHub.$emit('clearAnchor')
      }
    },
    close() {
      this.closeRightDrawer()
    },
    effectiveOpenDrawer() {
      this.openRightDrawer('communication', true)
    },
  },
}
</script>
